// extracted by mini-css-extract-plugin
export default {"spinner":"style_spinner__rJrv3","spinnerBlade":"style_spinnerBlade__pAl8u","spin":"style_spin__eTdk6","light":"style_light__bC4q-"};